/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: cda9ad104697
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  CreateFolderResponse,
  CreateFolderResponse$zodSchema,
} from "./createfolderresponse.js";

export type CreateFolderGlobals = { cloud_name?: string | undefined };

export const CreateFolderGlobals$zodSchema: z.ZodType<CreateFolderGlobals> = z
  .object({
    cloud_name: z.string().describe(
      "The cloud name of your product environment.",
    ).optional(),
  });

export type CreateFolderRequest = { folder: string };

export const CreateFolderRequest$zodSchema: z.ZodType<CreateFolderRequest> = z
  .object({
    folder: z.string().describe(
      "The full path of the folder, including any nested folders. Must not be empty, and must not contain double slashes or leading/trailing slashes.",
    ),
  });

export type CreateFolderResponseResponse = ApiError | CreateFolderResponse;

export const CreateFolderResponseResponse$zodSchema: z.ZodType<
  CreateFolderResponseResponse
> = z.union([
  ApiError$zodSchema,
  CreateFolderResponse$zodSchema,
]);
